import KnowioLogo from "../../assets/knowio-logo.png";

import { useEffect, useState, useRef, useMemo } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { getGroups, getPagedDevicesAPI, getSitesOnSchedule, getSiteAnalytics, getBranding } from "../../Api Methods/Api";
import { Await, useNavigate, Link } from "react-router-dom";
import DevicesList from "../../components/GridList/DevicesList";
import DataManager from "../../hooks/DataManager";
import DeviceLoadingGrid from "../../components/GridList/DeviceLoadingGrid";
import classes from '../OfflineSites/offlineSites.module.css'
import groupClasses from '../Groups/GroupSites.module.css'
import statClasses from "../../../src/Pages/Dashboard/Dashboard.module.css";
import StatCard from "../../components/UI/Stats/StatCard";
import SearchBar from "../SearchView/Search/SearchBar";
import { filter } from "rxjs";
import ScheduleSitesList from "../SitesOnSchedule/scheduleListSites";
import { Button } from "primereact/button";
import SitesOnScheduleSearchBar from "..//SitesOnSchedule/sitesOnScheduleSearchBar";
import ScheduledActionsList from "./scheduledActionsList";
import { fromUnixTime, set } from "date-fns";
import { serviceActions } from "../../store/service-Slice";
import mixpanel from "mixpanel-browser";
import { Dropdown } from "primereact/dropdown";
import { Doughnut, Bar } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement } from "chart.js";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { DatePickerPicker } from '../../components/sub-components/Logs/DatePickerModal';
import DatePickerModal from '../../components/sub-components/Logs/DatePickerModal'
import { DateRangePicker } from 'rsuite';
import { Dialog } from 'primereact/dialog';
import { SelectButton } from 'primereact/selectbutton';
import useSetCookie from '../../components/hooks/UseSetCookie';
import AllSitesSearchBar from "../AllSites/allSitesSearchBar";
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { format } from "date-fns";
import { logoMap } from "../../helpers/GroupLogoMap";

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement);

const centerTextPlugin = {
    id: "centerText",
    beforeDraw(chart) {
        const cfg = chart.config.options.plugins.centerText;
        if (!cfg?.show) return;
        const { ctx, chartArea } = chart;
        const cx = (chartArea.left + chartArea.right) / 2;
        const cy = (chartArea.top + chartArea.bottom) / 2;
        ctx.save();
        ctx.font = `600 16px -apple-system, BlinkMacSystemFont, sans-serif`;
        ctx.fillStyle = "#5c5c5c";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText(cfg.text, cx, cy);
        ctx.restore();
    },
};
ChartJS.register(centerTextPlugin);

const C = {
    online: "#60e08f",
    offline: "#ee6d6d",
    fair: "#87CEFA",
};

const makeOptions = (centerText) => ({
    responsive: true,
    maintainAspectRatio: false,
    cutout: "70%",
    plugins: {
        legend: {
            position: "bottom",
            labels: {
                font: { size: 11 },
                padding: 10,
                boxWidth: 10,
                usePointStyle: true,
                generateLabels: (chart) => {
                    const { labels, datasets } = chart.data;
                    return labels.map((label, i) => ({
                        text: `${label} - ${datasets[0].data[i].toLocaleString()}`,
                        fillStyle: datasets[0].backgroundColor[i],
                        strokeStyle: datasets[0].backgroundColor[i],
                        pointStyle: "circle",
                        hidden: false,
                        index: i,
                    }));
                },
            },
        },
        tooltip: { enabled: true },
        centerText: { show: true, text: centerText },
    },
});

const DonutCard = ({ title, labels, values, colors, centerText, chartRef }) => {
    const total = values.reduce((a, b) => a + b, 0);
    const data = {
        labels,
        datasets: [{ data: values, backgroundColor: colors, borderWidth: 0, hoverOffset: 4 }],
    };
    const displayText = centerText !== undefined ? centerText : total.toLocaleString();
    return (
        <div className={statClasses.chartCard}>
            <p className={statClasses.chartTitle}>{title}</p>
            <div className={statClasses.donutContainer} style={{ height: "180px"}}>
                <Doughnut ref={chartRef} data={data} options={makeOptions(displayText)} />
            </div>
        </div>
    );
};

const BarCard = ({ title, labels, datasets, chartRef }) => {
    const data = { labels, datasets };
    const hasMultipleDatasets = datasets && datasets.length > 1;
    return (
        <div className={statClasses.chartCard}>
            <p className={statClasses.chartTitle}>{title}</p>
            <div className={statClasses.barContainer} style ={{ height: "180px"}}>
                <Bar ref={chartRef} data={data} options={{ responsive: true, maintainAspectRatio: false, plugins: { legend: { display: hasMultipleDatasets }, tooltip: { enabled: true } }, scales: { x: { grid: { display: false } }, y: { beginAtZero: true, ticks: { stepSize: 1 } } } }} />
            </div>
        </div>
    );
};

const SkeletonChart = () => (
    <div className={statClasses.chartCard}>
        <div className={statClasses.skeletonBar} style={{ height: "14px", width: "55%", marginBottom: "16px" }} />
        <div className={statClasses.skeletonCircle} />
        <div className={statClasses.skeletonBar} style={{ height: "10px", width: "80%", marginTop: "14px" }} />
    </div>
);

const SkeletonBarChart = () => (
    <div className={statClasses.chartCard}>
        <div className={statClasses.skeletonBar} style={{ height: "14px", width: "40%", marginBottom: "16px" }} />
        <div className={statClasses.skeletonBar} style={{ height: "170px", width: "100%" }} />
    </div>
);

export const GsSkeletonMainTableCard = () => (
    <div className={statClasses.chartCard}>
        <div style={{ display: "flex", justifyContent: "space-between", padding: "30px 0", borderBottom: "1px solid rgba(0,0,0,0.05)" }}>
                <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
                <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
                <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
                <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
        </div>

        <div style={{ display: "flex", justifyContent: "space-between", padding: "30px 0", borderBottom: "1px solid rgba(0,0,0,0.05)" }}>
                <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
                <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
                <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
                <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
            </div>

        <div style={{ display: "flex", justifyContent: "space-between", padding: "30px 0", borderBottom: "1px solid rgba(0,0,0,0.05)" }}>
            <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
            <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
            <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
            <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", padding: "30px 0", borderBottom: "1px solid rgba(0,0,0,0.05)" }}>
            <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
            <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
            <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
            <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", padding: "30px 0", borderBottom: "1px solid rgba(0,0,0,0.05)" }}>
            <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
            <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
            <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
            <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", padding: "30px 0" }}>
            <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
            <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
            <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
            <div className={statClasses.skeletonBar} style={{ height: "18px", width: "24%" }} />
        </div>
    </div>
);


const ScheduledActionsSites = () => {

  const dataManager = new DataManager();
     
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const client = useSelector(state => state.auth.client);
  const token = useSelector(state => state.auth.token);
  const companyName = useSelector(state => state.auth.companyName);
  const role = useSelector(state => state.auth.role);
  localStorage.removeItem('DeviceUUID')
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const prevBody = useRef();
  const apiDataRef = useRef({ token, client, companyName });
  apiDataRef.current = { token, client, companyName };
  const apiData = {
      token,
      client
  }
 
  const [groups, setGroups] = useState([])
  const pageSize = 100;

  const cachedSites = useSelector(state => state.service.ScheduleSitesTableData);
  const [sites, setSites] = useState(cachedSites);
  const [visibleDevices, setVisibleDevices] = useState(
    cachedSites.slice(0, pageSize)
  );
  const [isLoading, setIsLoading] = useState(() => {
    return !cachedSites || cachedSites.length === 0;
  }); 
  const [isLoadingStats, setIsLoadingStats] = useState(true)
  const [filteredSites, setFilteredSites] = useState([]);
  
  const [selectedGroupFilter, setSelectedGroupFilter] = useState([])
  const [selectedFilter, setSelectedFilter] = useState("")
  const [daysFilter, setDaysFilter] = useState([])
  const [sortBy, setSortBy] = useState([])
  const [page, setPage] = useState(1);
  const [wHm, setWHm] = useState(false)
  const [woHm, setWoHm] = useState(false)
  const [excludeLocks, setExcludeLocks] = useState(false)
  const [excludePulse, setExcludePulse] = useState(false)
  const [portalSiteNameFilter, setPortalSiteNameFilter] = useState("")
  const [includes, setIncludes] = useState(true)
  const [refresh, setRefresh] = useState(0)
  const [sitesWithHolidayMode, setSitesWithHolidayMode] = useState("")
  const [fuzzySearch, setFuzzySearch] = useState(-1)
  const [siteLocation, setSiteLocation] = useState(null)
  const [siteType, setSiteType] = useState(null)
  const [CCTVType, setCCTVType] = useState(null)
  const [scheduleStats, setScheduleStats] = useState(null);
  const [scheduleTotal, setScheduleTotal] = useState(null);
  const [sitesAffected, setSitesAffected] = useState([]);
  const [sitesAffectedOriginal, setSitesAffectedOriginal] = useState([]);
  const [isLoadingScheduleStats, setIsLoadingScheduleStats] = useState(true);
  const [isLoadingStatCards, setIsLoadingStatCards] = useState(true);
  const savedState = JSON.parse(sessionStorage.getItem('groupScheduleFailState') || 'null');
  const [selectedIntegration, setSelectedIntegration] = useState(savedState ? savedState.selectedIntegration : "");
  const [selectedTime, setSelectedTime] = useState(savedState ? savedState.selectedTime : "7D");
  const [activeTab, setActiveTab] = useState(savedState ? savedState.activeTab : 0);
  const [sType, setSType] = useState(savedState ? savedState.sType : "");
  const [statusFilter, setStatusFilter] = useState(savedState ? savedState.statusFilter : ""); // add saved state stuff
  const [showSitesDialog, setShowSitesDialog] = useState(false);
  const scheduleRequestId = useRef(0);
  const [failsSearchTerm, setFailsSearchTerm] = useState(null);
  const [brandingName, setBrandingName] = useState("");
  const barChartRef = useRef(null);
  const donutChartRef = useRef(null);

  const times = ["7D", "1M", "3M"];

  const now = new Date();
  const last7 = new Date();
  last7.setDate(now.getDate() - 7);
  const last30 = new Date();
  last30.setDate(now.getDate() - 30);
  const last90 = new Date();
  last90.setDate(now.getDate() - 90);

   // daterange stuff
  const sixMonthsAgo = new Date();
  sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);

  const [dateRange, setDateRange] = useState(savedState ? savedState.dateRange : null);
  const [modalComponent, setModalComponent] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("Select a date range to view");

  const logo = logoMap[brandingName] || KnowioLogo

  
  const dayToIndex = {
    Mondays: "0",
    Tuesdays: "1",
    Wednesdays: "2",
    Thursdays: "3",
    Fridays: "4",
    Saturdays: "5",
    Sundays: "6",
  };

  const filterOptions = ["All", "Davantis", "Virtual", "iON"]

  const formatLocalDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}T12:00:00.000Z`;
  };

  const handleOK = (value) => {
    if (value) {
        setDateRange([formatLocalDate(value[0]), formatLocalDate(value[1])]);
        setSelectedTime(null)
    } else {
        setDateRange(null);
    }
  };

  const disableDates = (date) => {
    return date < sixMonthsAgo || date > now;
  };

  const HandleCloseModal = () => {
    setShowModal(false)
  };

  const onSelect = () => {
    HandleCloseModal();
  };

  const HandleLoadMore = () => {
    const nextPage = page + 1;
    const start = page * pageSize;
    const end = nextPage * pageSize;
    const nextDevices = filteredSites.slice(start, end);

    if (nextDevices.length > 0) {
      setVisibleDevices(prev => [...prev, ...nextDevices]);
      
      setPage(nextPage);
    }
  };



  useEffect(() => {
    if (savedState) {
      sessionStorage.removeItem('groupScheduleFailState');
    }
  }, [])

  useEffect(() => {
    const tabNumber = activeTab;

    const tabTracking = {
      0: "Scheduled Sites tab visited",
      1: "Group Schedule Analytics visted"
    };

    if (tabTracking[tabNumber]) {
      mixpanel.track(tabTracking[tabNumber], {
      user: localStorage.getItem('email')
      });
    }
  }, [activeTab])

  useEffect(() => {
    //setIsLoading(true)
    const getSites = async () => {
      const responseData = await getSitesOnSchedule(apiData, 0, dispatch)
      const raw = responseData.data[0]
      const parsed = raw.map(site => {
        let parsedDeviceDetails = {};
        let parsedDeviceExtraDetails = {};
        let parsedScheduledActions = {};

        try {
          parsedDeviceDetails = JSON.parse(site.deviceDetails || '{}');
        } catch (e) {
          console.warn(`Failed to parse deviceDetails for site ID ${site.id}`, e);
        }

        try {
          parsedDeviceExtraDetails = JSON.parse(site.deviceExtraDetails || '{}');
        } catch (e) {
          console.warn(`Failed to parse deviceExtraDetails for site ID ${site.id}`, e);
        }

        try {
          parsedScheduledActions = JSON.parse(site.scheduledActions || '{}');
        } catch (e) {
          console.warn(`Failed to parse scheduledActions for site ID ${site.id}`, e);
        }
        
        return {
          ...site,
          parsedDeviceDetails,
          parsedDeviceExtraDetails,
          parsedScheduledActions
        };
      });

      setSites(parsed);
      //dispatch
      dispatch(serviceActions.setScheduleSitesTableData(parsed));
      setIsLoading(false)
      setIsLoadingStats(false)
    };

    const GetGroups = async () => {
      try {
        const listOptions = await getGroups(apiData, dispatch);
        const groupNames = listOptions.map(group => group.name).sort((a, b) => a.localeCompare(b));
        setGroups(groupNames || []);
      } catch (error) {
        setGroups([]);
      }
    };

    getSites();
    GetGroups();
    // getSitesWithHolidayMode();
  }, [refresh]);

  const GetBrandingName = async (groupName) => {
    let body = {
        groupName: groupName ?? companyName
    }

    const response = await getBranding(apiData, body, dispatch)
    if (response.success){
        setBrandingName(response.data["emailBranding"])
    }
  }

  useEffect(() => {
    GetBrandingName();
  }, [companyName])

  useEffect(() => {
        const currentRequestId = ++scheduleRequestId.current;
        setScheduleStats([]);
        setSitesAffected([]);
        setSitesAffectedOriginal([]);
        setScheduleTotal(0);
        setIsLoadingScheduleStats(true);
        setIsLoadingStatCards(true);

        const FetchScheduleStats = async () => {
            const response = await getSiteAnalytics(apiDataRef.current, {
                siteUUID: statusFilter === "Exclude Online" ? "Online" : statusFilter === "Exclude Offline" ? "Offline" : "",
                groupName: apiDataRef.current.companyName || localStorage.getItem('companyName'),
                integration_type: selectedIntegration === "All" ? "" : selectedIntegration === "Ganz AIBOX" ? "AIBOX" : selectedIntegration?.toUpperCase() || "" ,
                siteType: sType || "", 
                start_date: selectedTime ? (selectedTime === "7D" ? last7 : selectedTime === "1M" ? last30 : last90) : (dateRange ? new Date(dateRange[0]) : last7),
                end_date: selectedTime ? now : dateRange ? new Date(dateRange[1]) : now,
                analyticsType: "schedules"
            }, dispatch);
            console.log(response);
            if (currentRequestId !== scheduleRequestId.current) return;
            setScheduleStats(response?.data?.[0]?.failures || []);
            setScheduleTotal(response?.data?.[0]?.scheduleCount.expectedSchedules || 0);
            //setScheduleTotal(response?.data?.[0]?.totalSuccess?.total_success || 0);
            const sitesWithIds = (response?.data?.[0]?.sitesAffected || []).map((site, index) => ({
                ...site,
                rowId: `${site.siteID}-${site.pin}-${site.subType}-${index}`
            }));
            setSitesAffectedOriginal(sitesWithIds);
            setSitesAffected(sitesWithIds);
            setIsLoadingScheduleStats(false);
            setIsLoadingStatCards(false);
        };

        FetchScheduleStats();
    }, [selectedTime, selectedIntegration, dateRange, sType, statusFilter]); 

  useEffect(() => {
    if (!failsSearchTerm) {
      setSitesAffected(sitesAffectedOriginal);
      return;
    }
    const filtered = sitesAffectedOriginal.filter((site) =>
      Object.values(site).some((value) =>
        value?.toString().toLowerCase().includes(failsSearchTerm.toLowerCase())
      )
    );
    setSitesAffected(filtered);
  }, [failsSearchTerm, sitesAffectedOriginal])

  useEffect(() => {
    if (!sites || sites.length === 0) return;
    let filtered;

    if (wHm) {
      filtered = [...sitesWithHolidayMode];
    } else if (woHm) {
      const holidayUuids = new Set(sitesWithHolidayMode.map(site => site.uuid));
      filtered = sites.filter(site => !holidayUuids.has(site.uuid));
    } else {
      filtered = [...sites];
    }

    if (selectedGroupFilter.length > 0) {
      filtered = filtered.filter(site => selectedGroupFilter.includes(site.name));
    }

    if (selectedFilter.length > 0) {
      if (selectedFilter.includes("Online")) {
        filtered = filtered.filter(site => site.online === "YES");
      }

      if (selectedFilter.includes("Offline")) {
        filtered = filtered.filter(site => site.online === "NO");
      }

      if (selectedFilter.includes("No portal site name")) {
        filtered = filtered.filter(site => site.tag == "");
        
      }

      if (selectedFilter.includes("Only active sites")) {
        filtered = filtered.filter(site => site.active == 1);
      }

      if (selectedFilter.includes("Only inactive sites")) {
        filtered = filtered.filter(site => site.active == 0);
      }
    }

    if (daysFilter.length > 0) {
      filtered = applyDayFilter(filtered, daysFilter, fuzzySearch);
    }

    if (searchTerm !== "" && (searchTerm !== dataManager.getItem('scheduleSitesSearchTerm'))){
      filtered = filtered.filter((item) =>
        Object.values(item)
          .some((value) => value?.toString().toLowerCase().includes(searchTerm.toLowerCase()))
      );
      dataManager.setItem('scheduleSitesSearchTerm', searchTerm)
    }

    if (portalSiteNameFilter !== ""){
      if (includes) {
        filtered = filtered.filter(item =>
          item?.tag?.toString().toLowerCase().includes(portalSiteNameFilter.toLowerCase())
        );
      } else {
        filtered = filtered.filter(item =>
          !item?.tag?.toString().toLowerCase().includes(portalSiteNameFilter.toLowerCase())
        );
      }
    }

    if (sortBy.length > 0) {
      const outputPinIds = {
        "Output 1 active": "5",
        "Output 2 active": "6",
        "Output 3 active": "13",
        "Output 4 active": "19",
      };

      const outputPinValues = Object.values(outputPinIds);

      if (sortBy.includes("Single pin sites")) {
        filtered = filtered.filter(site => {
          const details = site.parsedDeviceDetails;

          const activeOutputCount = outputPinValues.reduce((count, pinId) => {
            const pin = details[pinId];
            return pin?.active === 1 ? count + 1 : count;
          }, 0);

          return activeOutputCount === 1;
        });
      }

      if (sortBy.includes("Multi pin sites")) {
        filtered = filtered.filter(site => {
          const details = site.parsedDeviceDetails;

          const activeOutputCount = outputPinValues.reduce((count, pinId) => {
            const pin = details[pinId];
            return pin?.active === 1 ? count + 1 : count;
          }, 0);

          return activeOutputCount > 1;
        });
      }

      const outputFilters = sortBy.filter(item => outputPinIds[item]);
      const selectedPinIds = outputFilters.map(label => outputPinIds[label]);

      if (selectedPinIds.length > 0) {
        filtered = filtered.filter(site => {
          const details = site.parsedDeviceDetails;

          return outputPinValues.every(pinId => {
            const pin = details[pinId];
            const shouldBeActive = selectedPinIds.includes(pinId);
            return shouldBeActive
              ? pin?.active === 1
              : !pin || pin.active !== 1;
          });
        });
      }
    }

    if (excludePulse) {
      filtered = filtered.filter(site => {
        const details = site.parsedDeviceDetails;

        for (const pinId in details) {
          const pin = details[pinId];
          if (pin?.type === "PULSE" || pin?.type === "VIRTUAL_PULSE") {
            return false; // Exclude this site
          }
        }

        return true;
      });
    }

     if (siteLocation != null){
        filtered = filtered.filter(item =>
          item?.country_code?.includes(siteLocation.code)
        );
      }

      if (CCTVType != null){
        if (CCTVType == "Ganz Aibox"){
          setCCTVType("AIBOX")
        }
        console.log(CCTVType);
        console.log(filtered);
            filtered = filtered.filter(item =>
              item?.integrationType?.includes(CCTVType.toUpperCase())
            );
      }

      if (siteType != null){
        filtered = filtered.filter(item =>
          item?.site_type?.includes(siteType.label)
        );
      }

    setFilteredSites(filtered);
    setVisibleDevices(filtered.slice(0, pageSize));
    setPage(1);

    let mixPanelBody = {
      selectedGroupFilter: selectedGroupFilter,
      selectedFilter: selectedFilter,
      sortBy: sortBy,
      wHm: wHm,
      woHm: woHm,
      excludeLocks: excludeLocks,
      excludePulse: excludePulse,
      portalSiteNameFilter: portalSiteNameFilter,
      includes: includes,
      daysFilter: daysFilter,
      fuzzySearch: fuzzySearch,
      "searchTerm": searchTerm
    }

    const timer = setTimeout(() => {
    if (prevBody.current && (JSON.stringify(mixPanelBody) !== JSON.stringify(prevBody.current))) {
      mixpanel.track("Scheduled sites search performed", {
          user: localStorage.getItem('email'),
          body: mixPanelBody
        });
      }
      prevBody.current = mixPanelBody
    }, 2000);
    return () => clearTimeout(timer);
  }, [sites, selectedGroupFilter, selectedFilter, searchTerm, sortBy, wHm, woHm, excludeLocks, excludePulse, portalSiteNameFilter, includes, daysFilter, fuzzySearch, siteType, siteLocation, CCTVType]);


  function applyDayFilter(devices, daysFilter, fuzzySearch) {
    const dayIndexes = daysFilter.map(day => dayToIndex[day]);
  
    return devices
      .filter(site =>
        site.parsedScheduledActions?.some(schedule => {
          return dayIndexes.some(dayIndex =>
            fuzzySearch === 1
              ? schedule.days.includes(dayIndex)
              : schedule.days === `["${dayIndex}"]`
          );
        })
      )
      .map(site => {
        const matchingSchedules = site.parsedScheduledActions.filter(schedule =>
          dayIndexes.some(dayIndex =>
            fuzzySearch === 1
              ? schedule.days.includes(dayIndex)
              : schedule.days === `["${dayIndex}"]`
          )
        );
  
        return {
          ...site,
          parsedScheduledActions: matchingSchedules,
        };
      });
  }

  const calculateStability = (success, fail) => {
  if ((success == null || success === 0 || !success) && (fail == null || fail === 0 || !fail)) { return 'N/A' } 
  const total = success + fail;
  const successRate = total === 0 ? 0 : parseFloat((success / total * 100).toFixed(1));
  return successRate;
  }

  const getScheduleStats = () => {
        if ((!scheduleStats || scheduleStats.length === 0) && (!scheduleTotal || scheduleTotal === 0)) return { total: 0, totalFails: 0, successRate: 0,  totalSuccess: 0, totalArmFails: 0, totalDisarmFails: 0, data: [], uniqueSiteFailsLength: 0, uniqueSiteFails: [] };

        const dataSource = scheduleStats || [];

        const totalFails = dataSource.reduce((total, item) => total + item.disarmed_fail + item.armed_fail, 0);
        const total = scheduleTotal;
        const totalSuccess = scheduleTotal - totalFails;
        const totalArmFails = dataSource.reduce((total, item) => total + item.armed_fail, 0);
        const totalDisarmFails = dataSource.reduce((total, item) => total + item.disarmed_fail, 0);
        const successRate = total === 0 ? 0 : parseFloat((totalSuccess / total * 100).toFixed(1));

        const siteMap = {};
        (sitesAffected || []).forEach(item => {
          if (!siteMap[item.siteID]) {
            siteMap[item.siteID] = {
              ...item,
              total_failures: item.total_failures || 0
            };
          } else {
            siteMap[item.siteID].total_failures += item.total_failures || 0;
          }
        });
        const uniqueSiteFails = Object.values(siteMap);

        return { total, totalFails, successRate,  totalSuccess, totalArmFails, totalDisarmFails, data: dataSource, uniqueSiteFailsLength: uniqueSiteFails.length, uniqueSiteFails: uniqueSiteFails };
    }

    const generatePDF = () => {
      const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
      const pageW = doc.internal.pageSize.getWidth();
      const margin = 18;

      let startDate, endDate;
      if (selectedTime) {
          endDate = now;
          startDate = selectedTime === "7D" ? last7 : selectedTime === "1M" ? last30 : last90;
      } else if (dateRange) {
          startDate = new Date(dateRange[0]);
          endDate = new Date(dateRange[1]);
      } else {
          startDate = last7;
          endDate = now;
      }
      const dateRangeStr = `${format(startDate, "MMM d, yyyy")} - ${format(endDate, "MMM d, yyyy")}`;

      doc.setFont('helvetica', 'bold');
      doc.setFontSize(14);
      const titleText = `${apiDataRef.current.companyName || localStorage.getItem('companyName') || ""} - Schedule Fails`;
      const titleMaxWidth = pageW - margin * 2 - 25;
      const titleLines = doc.splitTextToSize(titleText, titleMaxWidth);
      const extraTitleHeight = (titleLines.length - 1) * 6;
      const headerHeight = 36 + extraTitleHeight;

      doc.setFillColor(28, 37, 54);
      doc.rect(0, 0, pageW, 32, 'F');

      if (logo) {
          const logoWidth = 17;
          const logoHeight = 17;
          const logoX = pageW - margin - logoWidth;
          const logoY = 4;
          doc.addImage(logo, 'PNG', logoX, logoY, logoWidth, logoHeight);
      }

      doc.setTextColor(255, 255, 255);
      doc.text(titleLines, margin, 10);

      let headerY = 10 + (titleLines.length * 2);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(12);
      doc.setFontSize(9);
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(180, 195, 220);
      doc.text(dateRangeStr, margin, headerY + 7);
      doc.text(`Generated: ${format(new Date(), "MMM d, yyyy")}`, margin, headerY + 12);
      
      const filename = `schedules-report-${apiDataRef.current.companyName.toLowerCase() || localStorage.getItem('companyName').toLowerCase() || ""}-${format(new Date(), "yyyy-MM-dd")}.pdf`;

      let curY = headerHeight + 10;

      if (barChartRef.current) {
        const chart = barChartRef.current;

        chart.resize(700, 200);
        chart.update('none');

        const chartImage = chart.toBase64Image();

        chart.resize();
        chart.update('none');
        doc.addImage(chartImage, 'PNG', 15, curY, 180, 55);
        curY += 60;
      }
      if (donutChartRef.current) {
        const chart = donutChartRef.current;

        chart.resize(300, 300);

        const chartImage = chart.toBase64Image();

        chart.resize();

        doc.addImage(chartImage, 'PNG', 65, curY, 70, 70);
        curY += 75;
      }

      curY += 5;
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(11);
      doc.setTextColor(30, 30, 30);
      doc.text('Schedule Report Details', margin, curY);
      curY += 6;

      const tableData = sitesAffected.map(row => [
          row.siteKey,
          row.siteName || '[No Name Set]',
          formatPin(row.pin),
          row.subType,
          row.total_failures,
          row.integrationType === 'AIBOX' ? 'Ganz AIBOX' : row.integrationType ? row.integrationType.charAt(0).toUpperCase() + row.integrationType.slice(1).toLowerCase() : "N/A",
          row.missedPolls == null ? 'N/A' : row.integrationType === 'CAMECT' ? 'N/A' : row.missedPolls >= 3 && row.polledAt == null ? `Offline since ${formatEventDate(row.polledAt, 'standard')}` : "Online",
          row.integrationType !== null && row.integrationType !== "CAMECT" ? `${calculateStability(row.success_count, row.failure_count)}%` : 'N/A',
          formatEventDate(row.latest_failure, 'standard')
      ]);

      autoTable(doc, {
          startY: curY,
          margin: { left: margin, right: margin },
          head: [['Site ID', 'Name', 'Output', 'Fail Type', 'Total Failures', 'Integration', 'Device Status', 'Stability', 'Latest Failure']],
          body: tableData,
          headStyles: { fillColor: [28, 37, 54], textColor: [255, 255, 255], fontSize: 8, fontStyle: 'bold' },
          bodyStyles: { fontSize: 8, textColor: [50, 50, 50] },
          alternateRowStyles: { fillColor: [249, 250, 251] },
          columnStyles: {
              0: { cellWidth: 18 },
              1: { cellWidth: 30 },
              2: { halign: 'center', cellWidth: 16 },
              3: { halign: 'center', cellWidth: 18 },
              4: { halign: 'center', cellWidth: 18 },
              5: { halign: 'center', cellWidth: 22 },
              6: { halign: 'center', cellWidth: 22 },
              7: { halign: 'center', cellWidth: 18 },
              8: { halign: 'center', cellWidth: 22 },
          },
          styles: { cellPadding: 3 },
      });

      const pageH = doc.internal.pageSize.getHeight();
      doc.setFillColor(28, 37, 54);
      doc.rect(0, pageH - 14, pageW, 14, 'F');
      doc.setTextColor(180, 195, 220);
      doc.setFontSize(7);
      doc.setFont('helvetica', 'normal');
      doc.text('Portal Analytics Report', pageW / 2, pageH - 6, { align: 'center' });
      doc.save(filename);

    }

  
  const HandleHolidayModeStatClick = () => {
    setWHm(true)
    setWoHm(false)
  }

  const HandleTotalSitesStatClick = () => {
    setSelectedFilter("")
    setSortBy([])
    setSelectedGroupFilter([])
    setWHm(false)
    setWoHm(false)
    setExcludeLocks(false)
    setExcludePulse(false)
  }

  // for date range charts
  const getDaysBetween = (start, end) => {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const timeDiff = Math.abs(endDate - startDate);
    return Math.ceil(timeDiff / (1000 * 60 * 60 * 24)) + 1;
  };

  // getting proper period to use for chart
  const getPeriod = () => {
    if (selectedTime) return selectedTime;
    if (!dateRange) return "7D";
    const days = getDaysBetween(dateRange[0], dateRange[1]);
    if (days <= 10) return "7D";
    if (days <= 45) return "1M";
    return "3M";
  };

  const period = getPeriod();

  // for schedules ,, missing dates
  const processedScheduleData = useMemo(() => {
    if (!scheduleStats) return [];

    let days;
    let startDate;

    if (selectedTime) {
      days = selectedTime === "7D" ? 8 : selectedTime === "1M" ? 30 : 90;
      startDate = new Date();
      startDate.setDate(startDate.getDate() - (days - 1));
    } else if (dateRange) {
      days = getDaysBetween(dateRange[0], dateRange[1]);
      startDate = new Date(dateRange[0]);
    } else {
      days = 8;
      startDate = new Date();
      startDate.setDate(startDate.getDate() - 7);
    }

    const result = Array.from({ length: days }, (_, i) => {
      const date = new Date(startDate);
      date.setDate(startDate.getDate() + i);
      return {
        event_date: date.toISOString().split('T')[0],
        armed_fail: 0,
        disarmed_fail: 0
      };
    });

    // replace 0s
    scheduleStats.forEach(item => {
      const dateKey = new Date(item.event_date).toISOString().split('T')[0];
      const match = result.find(r => r.event_date === dateKey);
      if (match) {
        match.armed_fail = item.armed_fail;
        match.disarmed_fail = item.disarmed_fail;
      }
    });

    return result;
  }, [scheduleStats, selectedTime, dateRange]);


  const formatEventDate = (dateStr, period) => {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        if (Number.isNaN(date.getTime())) return dateStr;
        

        switch (period) {
        case '7D':
            return date.toLocaleDateString('en-US', { weekday: 'short' });
        case '1M':
            return `${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
        case '3M':
            return date.toLocaleDateString('en-US', { month: 'short', day: '2-digit' });
        case 'standard':
            return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
        default:
            return dateStr;
        }
    };

    const formatPin = (pin) => {
      switch (pin) {
        case 5:
          return "Pin 1";
        case 6:
          return "Pin 2";
        case 13:
          return "Pin 3";
        case 19:
          return "Pin 4";
        case 25:
          return "Pin 5";
        case 26:
          return "Pin 6";
        case 27:
          return "Pin 7";
        case 28:
          return "Pin 8";
        default:
          return pin;
      }
    };

    const HandleUipiodOnClick = () => {
      sessionStorage.setItem('groupScheduleFailState', JSON.stringify({
        activeTab,
        selectedTime,
        selectedIntegration,
        sType,
        statusFilter,
        dateRange
      }))

      /*
      dispatch(serviceActions.setDeviceUUID(DeviceUUID));
      useSetCookie("DeviceUUID", DeviceUUID, 1);
      navigate("/Dashboard/SiteView/" + DeviceUUID);
      */
    }

    const HandleNavClick = () => {
      sessionStorage.setItem('groupScheduleFailState', JSON.stringify({
        activeTab,
        selectedTime,
        selectedIntegration,
        sType,
        statusFilter,
        dateRange
      }))
    }

    
  return (
    <Await resolve={visibleDevices}>
      {(loadedSites) => {
        return (
          <>
            <div style={{ width: "100%"}}>
              <div style={{ display: "flex", gap: "var(--gap-lg)", marginBottom: "8px", justifyContent: "start" }}>
                {activeTab === 0 ? (
                  <StatCard title={"Scheduled sites"} value={sites.length} isLoading={isLoadingStats} onClick={HandleTotalSitesStatClick} />
                ) : (
                  <>
                  <StatCard title={"Est. Schedule Count"} value={scheduleTotal} isLoading={isLoadingStatCards} />
                  <StatCard title={"Est. Success Rate"} value={`${getScheduleStats().successRate}%`} isLoading={isLoadingStatCards} />
                  </>
                )}

               {/* <StatCard title={"Schedule events"} value={getScheduleStats().total} isLoading={isLoadingStatCards} /> */}
                {/* <StatCard title={"Successful triggers"} value={getScheduleStats().totalSuccess} isLoading={isLoadingStatCards} /> */}
                <StatCard 
                    title={"Failed triggers"} 
                    value={getScheduleStats().totalFails} 
                    hasLabel={true} 
                    label={selectedTime === '7D' ? 'Past 7 days' : selectedTime === '1M' ? 'Past 30 days' : selectedTime === '3M' ? 'Past 90 days' : ''} 
                    isLoading={isLoadingStatCards} 
                />
                <StatCard
                  title={"Affected Sites"}
                  value={getScheduleStats().uniqueSiteFailsLength}
                  hasLabel={true}
                  label="Click to view"
                  isLoading={isLoadingStatCards}
                  onClick={() => setShowSitesDialog(true)}
                />
                {/* <StatCard title={"Success rate"} value={`${getScheduleStats().successRate}%`} isLoading={isLoadingStatCards} /> */}
              </div>

              <br></br>

              <div className={classes.tabsWrapper}>
                  <div className={classes.tabs}>
                      {["Scheduled sites", ...(role === "admin" || role === "TechSupport" ? ["Analytics"] : [])].map((tab, i) => (
                          <button
                              key={tab}
                              className={`${classes.tab} ${activeTab === i ? classes.active : ""}`}
                              onClick={() => setActiveTab(i)}
                          >
                              {tab}
                          </button>
                      ))}
                  </div>

                  <div className={classes.tabContent}>
                      {activeTab === 0 && (
                          isLoading ? (
                              <div style={{ display: "flex", width: "100%" }}>
                                  <DeviceLoadingGrid CardCount={20} />
                              </div>
                          ) : (
                              <>
                                  <div className={classes.searchContainer}>
                                      <SitesOnScheduleSearchBar
                                          type="text"
                                          placeholder="Search..."
                                          value={searchTerm}
                                          onChange={(e) => setSearchTerm(e.target.value)}
                                          showFilterButton={true}
                                          groups={groups}
                                          selectedGroupFilter={selectedGroupFilter}
                                          setSelectedGroupFilter={setSelectedGroupFilter}
                                          selectedFilter={selectedFilter}
                                          setSelectedFilter={setSelectedFilter}
                                          sortBy={sortBy}
                                          setSortBy={setSortBy}
                                          wHm={wHm}
                                          setWHm={setWHm}
                                          woHm={woHm}
                                          setWoHm={setWoHm}
                                          excludeLocks={excludeLocks}
                                          setExcludeLocks={setExcludeLocks}
                                          excludePulse={excludePulse}
                                          setExcludePulse={setExcludePulse}
                                          portalSiteNameFilter={portalSiteNameFilter}
                                          setPortalSiteNameFilter={setPortalSiteNameFilter}
                                          includes={includes}
                                          setIncludes={setIncludes}
                                          isSchedules={true}
                                          daysFilter={daysFilter}
                                          setDaysFilter={setDaysFilter}
                                          fuzzySearch={fuzzySearch}
                                          setFuzzySearch={setFuzzySearch}
                                          siteLocation={siteLocation}
                                          setSiteLocation={setSiteLocation}
                                          siteType={siteType}
                                          setSiteType={setSiteType}
                                          CCTVType={CCTVType}
                                          setCCTVType={setCCTVType}
                                          style={{
                                              padding: "10px",
                                              width: "300px",
                                              fontSize: "14px",
                                              boxSizing: "border-box",
                                              borderRadius: "4px",
                                          }}
                                      />
                                      <div>
                                          <p>{filteredSites.length} results</p>
                                      </div>
                                  </div>

                                  <ScheduledActionsList
                                      devices={loadedSites}
                                      refresh={refresh}
                                      setRefresh={setRefresh}
                                  />

                                  <div style={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      textAlign: 'center',
                                      marginTop: "15px"
                                  }}>
                                      {visibleDevices.length < filteredSites.length && <Button icon="pi pi-plus" style={{ width: "30%" }} label="Load more" onClick={HandleLoadMore} />}
                                  </div>
                              </>
                          )
                      )}

                      {activeTab === 1 && (
                        <>

                        <div>
                          <DatePickerModal show={showModal} onClose={HandleCloseModal} title={modalTitle} onSelect={onSelect}>
                            {modalComponent}
                          </DatePickerModal>
                        </div>

                        <div style={{display: "flex",justifyContent: "space-between"}}>
                          <div className={statClasses.timeButtons} style={{marginBottom: "10px"}}>
                            <AllSitesSearchBar 
                              type="text"
                              placeholder="Search sites affected..."
                              inputSearchBarStyle={classes.searchBar}
                              inputFilterIconStyle={classes.filterButton}
                              value={failsSearchTerm}
                              onChange={(e) => setFailsSearchTerm(e.target.value)}
                              showFilterButton={true}
                              showScheduleFilters={true}
                              setSelectedIntegration={setSelectedIntegration}
                              selectedIntegration={selectedIntegration}
                              setSType={setSType}
                              sType={sType}
                              setStatusFilter={setStatusFilter}
                              statusFilter={statusFilter}
                            />
                          </div>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', alignItems: "flex-end" }}>
                              <div className={statClasses.timeDropdown} style={{marginBottom: "10px", display: "flex", justifyContent: "flex-end"}}>
                                <DateRangePicker style={{
                                    display: "flex",
                                    border: "1px solid #00000099",
                                    borderRadius: "8px",
                                    height: "30px",
                                    maxWidth: "50%"
                                  }}
                                    format="yyyy.MM.dd"
                                    onChange={handleOK} // handle weird entries in dis func
                                    shouldDisableDate={disableDates}
                                    calendarSnapping={true}
                                    appearance="subtle"
                                    onClean={() => {
                                      setDateRange(null)
                                      setSelectedTime("7D")
                                    }}
                                    cleanable={true}
                                    ranges={[]}
                                    value={dateRange ? [new Date(dateRange[0]), new Date(dateRange[1])] : null}
                                  />
                                    {times.map((time) => (
                                        <button
                                            key={time}
                                            className={selectedTime === time ? statClasses.timeButtonActive : statClasses.timeButton}
                                            onClick={() => {
                                              setSelectedTime(time)
                                              setDateRange(null)
                                            }}
                                            
                                        >
                                            {time}
                                        </button>
                                    ))}
                              </div>
                              {getScheduleStats().totalFails > 0 && (
                                <Button
                                    label="Export PDF"
                                    icon="pi pi-file-pdf"
                                    style={{
                                        height: "28px",
                                        fontSize: "14px",
                                        padding: "6px 10px",
                                        lineHeight: "1",
                                        width: '125px'
                                    }}
                                    onClick={generatePDF}
                                />
                              )}
                            </div>
                        </div>
                            
                          <div className={statClasses.chartsRow} style={{ marginTop: "14px" }}>
                            {isLoadingScheduleStats ? (
                              <>
                              {/* 
                                <div className={statClasses.donutWrapper}>
                                  <SkeletonChart />
                                </div>
                              */}
                                <div className={statClasses.fullbarWrapper}>
                                  <SkeletonBarChart />
                                </div>
                              </>
                            ) : (
                              <>
                              
                                <div className={statClasses.donutWrapper}>
                                    {getScheduleStats().total === 0 ? (
                                        <div className={statClasses.chartCard}>
                                            <p className={statClasses.chartTitle}>Schedule success rate</p>
                                            <div style={{ height: "180px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                <p style={{ textAlign: "center", color: "#888888", margin: 0 }}>
                                                    No data for this period.
                                                </p>
                                            </div>
                                        </div>
                                    
                                    ) : (
                                        <DonutCard
                                            title="Schedule success rate"
                                            labels={["Success", "Arm failed", "Disarm failed"]}
                                            values={[getScheduleStats().totalSuccess, getScheduleStats().totalArmFails, getScheduleStats().totalDisarmFails]}
                                            colors={[C.online, C.offline, C.fair]}
                                            centerText={`${getScheduleStats().successRate}%`}
                                            chartRef={donutChartRef}
                                        />
                                    )}
                                </div>

                                <div className={statClasses.fullbarWrapper}>
                                    {getScheduleStats().totalFails === 0 ? (
                                        <div className={statClasses.chartCard}>
                                            <p className={statClasses.chartTitle}>Failed schedules over time</p>
                                            <div style={{ height: "180px", display: "flex", alignItems: "center", justifyContent: "center"}}>
                                                <p style={{ textAlign: "center", color: "#888888", margin: 0 }}>
                                                    No failed schedules for this period.
                                                </p>
                                            </div>
                                        </div>
                                    ) : (
                                        <BarCard
                                            title="Failed schedules over time"
                                            labels={processedScheduleData.map(item => formatEventDate(item.event_date, period))}
                                            datasets={[
                                                {
                                                    label: "Failed Arm Schedules",
                                                    data: processedScheduleData.map(item => item.armed_fail),
                                                    backgroundColor: C.offline,
                                                },
                                                {
                                                    label: "Failed Disarm Schedules",
                                                    data: processedScheduleData.map(item => item.disarmed_fail),
                                                    backgroundColor: C.fair,
                                                }
                                            ]}
                                            chartRef={barChartRef}
                                        />
                                    )}
                                </div>
                              </>
                            )}
                          </div>
                          <br />
                          {isLoadingScheduleStats ? (
                            <GsSkeletonMainTableCard />
                          ) : (
                            <>
                            <div className={statClasses.chartCard}>
                              <p className={statClasses.chartTitle}>Sites to Review</p>
                              <DataTable value={sitesAffected} paginator showGridlines={true} rows={20} rowsPerPageOptions={[20, 30, 40, 50, 100]} removableSort dataKey="rowId" emptyMessage="No site failures" >
                                <Column
                                  field="siteKey"
                                  header="Site ID"
                                  style={{ minWidth: "8rem" }}
                                  body={(rowData) => (
                                      <Link
                                        onClick={HandleUipiodOnClick}
                                        className={classes.tableUser}
                                        to={`/Dashboard/SiteView/${rowData.siteID}`}
                                      >
                                        {rowData.siteKey}
                                      </Link>
                                  )}
                                />
                                <Column field="siteName" header="Name" style={{ minWidth: "12rem" }} body={(rowData) => rowData.siteName || "[No Name Set]"} />
                                <Column field="pin" header="Output" style={{ minWidth: "6rem" }} body={(rowData) => formatPin(rowData.pin)} />
                                <Column field="subType" header="Fail type" style={{ minWidth: "8rem" }} />
                                <Column field="total_failures" header="Total failures" sortable style={{ minWidth: "8rem" }} />
                                <Column 
                                  field="integrationType" 
                                  header="Integration" 
                                  sortable 
                                  style={{ minWidth: "10rem" }} 
                                  body={(rowData) => 
                                    rowData.integrationType === "AIBOX" ? "Ganz AIBOX" : rowData.integrationType ? rowData.integrationType.charAt(0).toUpperCase() + rowData.integrationType.slice(1).toLowerCase() : "N/A"} />
                                <Column
                                  field="missedPolls"
                                  header="Device Status"
                                  style={{ minWidth: "8rem" }}
                                  body={(rowData) => (
                                    <span>
                                      {rowData.missedPolls == null ? "N/A" : rowData.integrationType === "CAMECT" ? "N/A" : rowData.missedPolls >= 3 && rowData.polledAt == null ? "Offline" : rowData.missedPolls >= 3 && rowData.polledAt !== null ? `Offline since ${formatEventDate(rowData.polledAt, 'standard')}` : "Online"}
                                    </span>
                                  )}
                                  sortable />
                                
                                <Column 
                                  header="Stability" 
                                  style={{ minWidth: "6rem" }} 
                                  body={(rowData) => rowData.integrationType !== null && rowData.integrationType !== "CAMECT" ?
                                    `${calculateStability(rowData.success_count, rowData.failure_count)}%`
                                    : 'N/A'
                                  }
                                  sortField="success_count"
                                  sortable />
                                <Column field="latest_failure" header="Latest failure" sortable style={{ minWidth: "12rem" }} body={(rowData) => formatEventDate(rowData.latest_failure, "standard")} />
                              </DataTable>
                              </div>
                            </>
                          )}
                      </>
                      )}
                  </div>
              </div>
            </div>

            <Dialog
              header="Affected Sites"
              visible={showSitesDialog}
              style={{ width: '75vw' }}
              onHide={() => setShowSitesDialog(false)}
            >
              <DataTable
                value={getScheduleStats().uniqueSiteFails}
                paginator
                rows={20}
                rowsPerPageOptions={[20, 30, 40, 50, 100]}
                showGridlines
                emptyMessage="No affected sites"
                removableSort
              >
                <Column 
                  field="siteKey" 
                  header="Site ID"
                  body={(rowData) => (
                    <Link
                      onClick={HandleUipiodOnClick}
                      className={classes.tableUser}
                      to={`/Dashboard/SiteView/${rowData.siteID}`}
                    >
                      {rowData.siteKey}
                    </Link>
                  )} />
                <Column field="siteName" header="Name" body={(rowData) => rowData.siteName || "[No Name Set]"} />
                <Column field="total_failures" header="Total Failures" sortable />
                <Column field="integrationType" header="Integration" sortable style={{ minWidth: "10rem" }} body={(rowData) => rowData.integrationType ? rowData.integrationType.charAt(0).toUpperCase() + rowData.integrationType.slice(1).toLowerCase() : "N/A"} />
                <Column
                  field="missedPolls"
                  header="Device Status"
                  body={(rowData) => (
                    <span>
                      {rowData.missedPolls == null ? "N/A" : rowData.integrationType === "CAMECT" ? "N/A" : rowData.missedPolls >= 3 ? "Offline" : "Online"}
                    </span>
                  )}
                  sortable />
                <Column field="latest_failure" header="Latest failure" sortable style={{ minWidth: "12rem" }} body={(rowData) => formatEventDate(rowData.latest_failure, "standard")} />
              </DataTable>
            </Dialog>
          </>

        )
      }}
    </Await>
  )
}

export default ScheduledActionsSites;